import React from "react";
import { Button, Radio, Select } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import { usePropertyContext } from "../../context";
import QuestionCard from "elements/QuestionCard";
import ButtonV2 from "elements/ButtonV2";

//Make sure this is consistent with getQuestions.tsx if any values are changed
const options = [
	{ label: "Alabama", value: "AL" },
	{ label: "Alaska", value: "AK" },
	{ label: "Arizona", value: "AZ" },
	{ label: "Arkansas", value: "AR" },
	{ label: "California", value: "CA" },
	{ label: "Colorado", value: "CO" },
	{ label: "Connecticut", value: "CT" },
	{ label: "Delaware", value: "DE" },
	{ label: "Florida", value: "FL" },
	{ label: "Georgia", value: "GA" },
	{ label: "Hawaii", value: "HI" },
	{ label: "Idaho", value: "ID" },
	{ label: "Illinois", value: "IL" },
	{ label: "Indiana", value: "IN" },
	{ label: "Iowa", value: "IA" },
	{ label: "Kansas", value: "KS" },
	{ label: "Kentucky", value: "KY" },
	{ label: "Louisiana", value: "LA" },
	{ label: "Maine", value: "ME" },
	{ label: "Maryland", value: "MD" },
	{ label: "Massachusetts", value: "MA" },
	{ label: "Michigan", value: "MI" },
	{ label: "Minnesota", value: "MN" },
	{ label: "Mississippi", value: "MS" },
	{ label: "Missouri", value: "MO" },
	{ label: "Montana", value: "MT" },
	{ label: "Nebraska", value: "NE" },
	{ label: "Nevada", value: "NV" },
	{ label: "New Hampshire", value: "NH" },
	{ label: "New Jersey", value: "NJ" },
	{ label: "New Mexico", value: "NM" },
	{ label: "New York", value: "NY" },
	{ label: "North Carolina", value: "NC" },
	{ label: "North Dakota", value: "ND" },
	{ label: "Ohio", value: "OH" },
	{ label: "Oklahoma", value: "OK" },
	{ label: "Oregon", value: "OR" },
	{ label: "Pennsylvania", value: "PA" },
	{ label: "Rhode Island", value: "RI" },
	{ label: "South Carolina", value: "SC" },
	{ label: "South Dakota", value: "SD" },
	{ label: "Tennessee", value: "TN" },
	{ label: "Texas", value: "TX" },
	{ label: "Utah", value: "UT" },
	{ label: "Vermont", value: "VT" },
	{ label: "Virginia", value: "VA" },
	{ label: "Washington", value: "WA" },
	{ label: "West Virginia", value: "WV" },
	{ label: "Wisconsin", value: "WI" },
	{ label: "Wyoming", value: "WY" },
];

const OutOfStateTaxReturn = () => {
	const { next, ownersValue, specialFieldsValue, setSpecialFieldsValue } =
		useExemptionsContext();
	const { details } = usePropertyContext();
	const trackEvent = useEventTracker();

	const handleSubmit = async () => {
		next();
	};

	const btnDisabled = React.useMemo(() => {
		if (
			specialFieldsValue?.self_or_spouse_has_out_of_state_tax_return ===
			undefined
		) {
			return true;
		} else if (
			specialFieldsValue?.self_or_spouse_has_out_of_state_tax_return === false
		) {
			return false;
		} else {
			return !specialFieldsValue?.self_or_spouse_out_of_state_tax_return_state;
		}
	}, [specialFieldsValue]);

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card">
				<div className="property-profile-question-card-top">
					<div className="property-profile-question-card-title-container">
						<p>
							Have you{" "}
							{ownersValue?.includes("Own With Spouse")
								? "or your spouse "
								: " "}
							filed a tax return as a non-resident of Michigan or resident of
							another state?
						</p>
						<div className="property-profile-question-card-radio">
							<Radio
								name="selfOrSpouseHasOutOfStateTaxReturn"
								checked={
									specialFieldsValue?.self_or_spouse_has_out_of_state_tax_return ===
									true
								}
								onChange={e => {
									setSpecialFieldsValue({
										self_or_spouse_has_out_of_state_tax_return: true,
									});
								}}
								value="Yes"
								label="Yes"
							/>
							<Radio
								name="selfOrSpouseHasOutOfStateTaxReturn"
								checked={
									specialFieldsValue?.self_or_spouse_has_out_of_state_tax_return ===
									false
								}
								onChange={e => {
									setSpecialFieldsValue({
										self_or_spouse_has_out_of_state_tax_return: false,
									});
								}}
								value="No"
								label="No"
							/>
						</div>
					</div>
				</div>
			</div>
			{specialFieldsValue?.self_or_spouse_has_out_of_state_tax_return && (
				<div className="property-profile-question-card exemption-survey-card">
					<div className="property-profile-question-card-title-container">
						<p>Which state was the tax return filed in?</p>
					</div>
					<Select
						className="exemptions-card-input"
						required
						value={
							specialFieldsValue?.self_or_spouse_out_of_state_tax_return_state ??
							""
						}
						onChange={e => {
							setSpecialFieldsValue({
								self_or_spouse_out_of_state_tax_return_state: e.target.value,
							});
						}}>
						<option value="" hidden disabled>
							State
						</option>
						{options.map(({ label, value }) => (
							<option key={label} value={value}>
								{label}
							</option>
						))}
					</Select>
				</div>
			)}

			<ButtonV2 size="large" disabled={btnDisabled} type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default OutOfStateTaxReturn;
